// extracted by mini-css-extract-plugin
module.exports = {"progressMessage":"TextCycler_progressMessage__XtdUY","progressMessageEllipsis":"TextCycler_progressMessageEllipsis__BKUeS"};